/**
 * MSW Override: Booking Detail Confirmable scenario
 *
 * Stateful per booking: the FIRST read passes through (DRAFT → the pay form
 * renders); every later read forces FORCED_STATUS. Refreshing the pay page then
 * exercises its load-time recovery (CONFIRMED → redirect to confirmation; set
 * 'HOLD' to exercise the in-progress poll). Start a new booking to see the
 * form again.
 *
 * Enable via ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_BOOKING_DETAIL_CONFIRMABLE=true.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse, bypass } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { BookingResponse, BookingStatus } from '@cvo/domain';

const FORCED_STATUS: BookingStatus = 'CONFIRMED';

const readOnceForBookingIds = new Set<string>();

export function createBookingDetailConfirmableOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING)}`,
      async ({ request, params }) => {
        const bookingId = params.bookingId as string;
        const originalResponse = await fetch(bypass(request));
        const data: BookingResponse = await originalResponse.json();

        if (!readOnceForBookingIds.has(bookingId)) {
          readOnceForBookingIds.add(bookingId);
          console.log('[MSW] booking detail confirmable: first read passes through (status', data.bookingStatus, ') for booking', bookingId);
          return HttpResponse.json(data, { status: originalResponse.status });
        }

        console.log('[MSW] booking detail confirmable: forcing status', FORCED_STATUS, 'for booking', bookingId);
        return HttpResponse.json({ ...data, bookingStatus: FORCED_STATUS }, { status: originalResponse.status });
      },
    ),
  ];
}
